import * as React from 'react';
export const logicbrokerSvg = React.forwardRef(function logicbrokerSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 0h32v32H0z',
      fill: '#f5f6f8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.99 16.423c.004-.13.01-.259.01-.39 0-.828-.085-1.655-.253-2.466l-.966.027a10.89 10.89 0 0 0-.793-2.261l.765-.642a12.1 12.1 0 0 0-1.546-2.372l-.893.502a11.063 11.063 0 0 0-1.818-1.645l.404-.984a11.955 11.955 0 0 0-2.464-1.338l-.594.918a10.923 10.923 0 0 0-2.388-.568l-.104-1.125c-.93-.11-1.87-.105-2.799.012l-.105 1.156a10.88 10.88 0 0 0-2.317.627l-.64-.99c-.872.354-1.699.811-2.464 1.36l.461 1.12c-.611.467-1.172.998-1.674 1.582l-1.05-.591a12.067 12.067 0 0 0-1.542 2.39l.937.788c-.303.665-.54 1.359-.704 2.071l-1.2-.035A12.143 12.143 0 0 0 4 16.033c0 .138.005.274.01.41l1.17.254c.037.692.14 1.38.306 2.053l-1.047.512c.261.941.636 1.847 1.117 2.697l1.109-.308c.335.575.722 1.117 1.156 1.621l-.659.9a12.02 12.02 0 0 0 2.238 1.91l.79-.742c.549.356 1.129.661 1.732.913l-.156 1.042c.924.349 1.887.581 2.868.692l.332-.958a10.881 10.881 0 0 0 1.982.026l.326.945c.98-.104 1.944-.329 2.868-.67l-.141-.953a10.898 10.898 0 0 0 1.848-.91l.693.653c.82-.536 1.573-1.17 2.241-1.887l-.548-.75a10.95 10.95 0 0 0 1.29-1.75l.906.25c.479-.845.854-1.744 1.117-2.68l-.833-.408c.194-.743.31-1.503.344-2.27zm-11.93 7.254a7.52 7.52 0 0 1-4.186-1.273 7.55 7.55 0 0 1-2.775-3.391 7.574 7.574 0 0 1 1.633-8.233 7.514 7.514 0 0 1 8.21-1.637 7.538 7.538 0 0 1 3.382 2.782 7.569 7.569 0 0 1-.937 9.54 7.523 7.523 0 0 1-5.327 2.212z',
      fill: '#e71618',
    }),
  );
});
logicbrokerSvg.defaultProps = {
  fill: 'none',
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var logicbroker = {
  category: 'brand',
  colorable: false,
  name: 'logicbroker',
  svg: logicbrokerSvg,
};
